import React, { useState, useEffect } from 'react';
import { FloatingWidget } from '@reviewshake-app/shake-ui';

const FloatingWidgetContainer = ({ data, reviews, onLoadMore, loading }) => {
  const [isVisible, setVisible] = useState(false);
  const waitingTime = data.waitingTime > 100 ? data.waitingTime : 100;

  useEffect(() => {
    const visibleTimeout = setTimeout(() => {
      setVisible(true);

      if ('parentIFrame' in window) {
        window['parentIFrame'].sendMessage({
          widgetType: data.widgetType,
          position: data.position,
          showOnMobile: data.showOnMobile,
          style: 'box-shadow:0 2px 16px 0 #e2e9f0;visibility:visible;opacity:1;',
        });
      }
    }, waitingTime);

    return () => {
      clearTimeout(visibleTimeout);
    };
  }, []);

  return isVisible ? (
    <FloatingWidget
      data={data}
      reviews={reviews}
      onLoadMore={onLoadMore}
      loading={loading}
      brandingLogo={data.brandingLogo}
      brandingName={data.brandingName}
    />
  ) : null;
};

export default FloatingWidgetContainer;
